module.exports = __webpack_public_path__ + "summernote.372a2830643e759ed61f.eot";


//////////////////
// WEBPACK FOOTER
// /rightcompound/angular/node_modules/summernote/dist/font/summernote.eot
// module id = ../../../../summernote/dist/font/summernote.eot
// module chunks = styles